import { DatePipe } from "@angular/common";
import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import * as moment from "moment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { Sucursal } from "src/app/models/Sucursal";
import { AuthService } from "src/app/modules/auth";
import { ChangeCompanyService } from "src/app/services/changecompany.service";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { EmisorService } from "src/app/services/emisor.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { PaykuService } from "src/app/services/payku.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { VerificacionCertificadoService } from "src/app/services/verificacion-certificado.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";
import { PermissionService } from "src/app/services/permission.service";
import { DeudaAdicionalPendiente } from "src/app/models/PlanesUsuario/DeudaAdicionalPendiente";
@Component({
	selector: "app-dashboard-widgets",
	templateUrl: "./dashboard-widgets.component.html",
	styleUrls: ["./dashboard-widgets.component.scss"],
})
export class DashboardWidgetsComponent implements OnInit, AfterViewInit, OnDestroy  {
	private readonly debtAlertStoragePrefix = "sf-deuda-adicional-alerta-";
	@ViewChild("currentSwal") public currentSwal: SwalComponent;
	public user: SessionUser;
	


	public planSeleccionado: Plan;
	public isReseller: boolean = this.tokenService.userHasReseller();
	@ViewChild("extendPlanForm", { static: true }) extendPlanForm: TemplateRef<any>;
	@ViewChild("changeCompanyForm", { static: true }) changeCompanyForm: TemplateRef<any>;
	public currentEmisorObject: Emisor;
	public emisoresSource: Emisor[];
	public showModal :boolean = false;
	public planes: Plan[];
	public datosFacturacion: EmpresaFacturacion;
	public planActual: PlanUsuario;

	public nuevaFechaCaducidad: moment.Moment;
	public fechaActual = moment();
	public certificaciones: CertificacionPrecio[];

	private unsubscribePlan$ = new Subject<void>();
	private unsubscribeEmisor$ = new Subject<void>();
	public showCuadroPayku: boolean = false;
	public hasPaykuAdicional: boolean = false; // Controla si tiene el adicional de Payku
	public hasPaykuAccount: boolean = false; // Controla si ya tiene cuenta activa de Payku
	constructor(
		public utilities: UtilitiesService,

		private changeCompanyService: ChangeCompanyService,
		private localStorage: LocalStorageService,
		private ref: ChangeDetectorRef,
		private tokenService: TokenStorageService,
		public planService: PlanUsuarioService,
		private router: Router,
		private paykuService: PaykuService,
		
		public datosFacturacionServicce: DatosFacturacionService,
		private validadorCertificadoService: VerificacionCertificadoService,
		public permissions: PermissionService,
		private userService: UsuarioService
	) {
		this.user = this.tokenService.getUser() as SessionUser;

		this.emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.currentEmisorObject = this.emisoresSource.find((x) => x.emisorId == this.tokenService.getCompany());
	}

	ngOnInit(): void {
		if (this.changeCompanyService.evaluarAccesoAlLogin()) return;

		this.planActual = this.changeCompanyService.verifyAlertPayment(this.user.planes, this.emisoresSource.length);
		
		this.changeCompanyService.companyChanged.pipe(takeUntil(this.unsubscribeEmisor$)).subscribe((newEmisor: Emisor) => {
			this.currentEmisorObject = newEmisor;
			this.validatePaykuAdicional();	
			this.validatePaykuAccount();
			this.validateModal();
			this.revisarDeudaAdicionalPendiente();
			this.ref.detectChanges();	
		});
		
		// Validar si tiene adicional de Payku
		this.validatePaykuAdicional();
		
		// Validar si tiene cuenta activa de Payku (solo si tiene adicional)
		this.validatePaykuAccount();

		// Ejecutar la validación del modal una sola vez tras las validaciones anteriores
		this.validateModal();
		this.revisarDeudaAdicionalPendiente();
	}

	ngOnDestroy(): void {
		// Emitir para desuscribirse de los observables
		this.unsubscribePlan$.next();
		this.unsubscribePlan$.complete();

		this.unsubscribeEmisor$.next();
		this.unsubscribeEmisor$.complete();
	  }
	private async validarCertificado() {
		const validacionCertificado = await this.validadorCertificadoService.validar();
	}

	ngAfterViewInit(): void {
		this.changeCompanyService.planChanged$
        .pipe(takeUntil(this.unsubscribePlan$))
        .subscribe((newPlan: PlanUsuario) => {
            this.planActual = newPlan;
            this.ref.detectChanges();
        });
	}

	private validatePaykuAdicional(): void {
		try {
			const raw = this.localStorage.getAdicionales();
			const adicionales = Array.isArray(raw)
				? raw
				: (typeof raw === 'string' ? JSON.parse(raw) : []);
			this.hasPaykuAdicional = adicionales?.some((a: any) => a?.idAdicional === 5) || false;
			this.ref.detectChanges();
		} catch {
			this.hasPaykuAdicional = false;
			this.ref.detectChanges();
		}
	}

	private validatePaykuAccount(): void {
		if (!this.hasPaykuAdicional) {
			this.hasPaykuAccount = false;
			this.updateShowCuadroPayku();
			return;
		}

		this.paykuService.hasActiveAccount(this.currentEmisorObject.emisorId).subscribe({
			next: (resp) => {
				this.hasPaykuAccount = !!resp?.data;
				this.updateShowCuadroPayku();
			},
			error: (err) => {
				console.error('Error verificando cuenta Payku:', err);
				this.hasPaykuAccount = false;
				this.updateShowCuadroPayku();
			}
		});
	}

	private updateShowCuadroPayku(): void {
		// Mostrar cuadro solo si: tiene adicional Y NO tiene cuenta activa
		this.showCuadroPayku = this.hasPaykuAdicional && !this.hasPaykuAccount;
		this.ref.detectChanges();
	}

	private validateModal(): void {
		if (!this.hasPaykuAdicional) {
			const usuarioId = this.user?.id;
			if (usuarioId) {
				this.paykuService.getNoticia(usuarioId).subscribe({
					next: (resp) => {
						const shouldShow = resp?.data;
						this.showModal = shouldShow && !this.hasPaykuAdicional;
						this.ref.detectChanges();
					},
					error: (err) => {
						console.error('[DashboardWidgets] getNoticia error:', err);
						this.showModal = false;
						this.ref.detectChanges();
					},
				});
			} else {
				this.showModal = false;
				this.ref.detectChanges();
			}
		} else {
			// Si tiene adicional, no mostrar el modal
			this.showModal = false;
			this.ref.detectChanges();
		}
	}
	closeModal(): void {
    	this.showModal = false;
  	}

	handleDontShowAgain(): void {
		const usuarioId = this.user?.id;
		if (!usuarioId) { this.closeModal(); return; }
		this.paykuService.desactivarNoticia(usuarioId).subscribe({
			next: (resp) => {
				// resp: { status, message, data }
				if (resp?.status === 200 && resp?.data) {
					Swal.fire({ icon: 'success', title: 'Listo', text: resp.message || 'Noticia desactivada.' });
				} else {
					Swal.fire({ icon: 'error', title: 'Error', text: resp?.message || 'No se pudo desactivar la noticia.' });
				}
				this.closeModal();
			},
			error: (err) => {
				const msg = err?.error?.message || 'No se pudo desactivar la noticia.';
				Swal.fire({ icon: 'error', title: 'Error', text: msg });
				this.closeModal();
			},
		});
	}

	activatePayku(): void {
		this.closeModal();
		this.router.navigate(["/configuracion", "payku"]);
	}

	private revisarDeudaAdicionalPendiente(): void {
		if (this.isReseller || !this.currentEmisorObject?.emisorId || !this.currentEmisorObject?.activo) {
			return;
		}

		if (this.planActual && this.planActual.diasDiferencia < 0) {
			return;
		}

		this.userService.getUser(this.user.id, this.currentEmisorObject.emisorId).subscribe({
			next: (response) => {
				if (!this.usuarioPuedeAdministrarPlan(response)) {
					return;
				}

				this.planService.getPendingAdditionalDebt(this.currentEmisorObject.emisorId).subscribe({
					next: (deuda: DeudaAdicionalPendiente) => {
						const emisorConDeudaId = deuda?.emisorId || this.currentEmisorObject.emisorId;
						if (!deuda?.tieneDeuda || this.deudaYaFueNotificada(emisorConDeudaId)) {
							return;
						}

						this.marcarDeudaComoNotificada(emisorConDeudaId);
						Swal.fire({
							icon: "warning",
							title: "Tienes adicionales pendientes de pago",
							html: `
								<p class="mb-2">Detectamos <strong>${deuda.cantidadFacturas}</strong> factura(s) pendiente(s) por adicionales o certificaciones.</p>
								<p class="mb-0">Monto total estimado: <strong>$${deuda.totalPendiente.toLocaleString("es-CL")}</strong></p>
							`,
							showCancelButton: true,
							confirmButtonText: "Revisar detalle",
							cancelButtonText: "Más tarde",
						}).then((result) => {
							if (result.isConfirmed) {
								this.revisarDetalleDeudaAdicional(deuda);
							}
						});
					},
					error: () => undefined,
				});
			},
			error: () => undefined,
		});
	}

	private usuarioPuedeAdministrarPlan(response: any): boolean {
		return Array.isArray(response?.data?.planesUsuario) && response.data.planesUsuario.length > 0;
	}

	private revisarDetalleDeudaAdicional(deuda: DeudaAdicionalPendiente): void {
		const emisorConDeudaId = deuda?.emisorId;
		if (!emisorConDeudaId || emisorConDeudaId === this.currentEmisorObject?.emisorId) {
			this.router.navigateByUrl("/plan-facturacion");
			return;
		}

		const emisorConDeuda = this.emisoresSource.find((emisor) => emisor.emisorId === emisorConDeudaId);
		if (!emisorConDeuda) {
			this.router.navigateByUrl("/plan-facturacion");
			return;
		}

		this.tokenService.setCompany(emisorConDeuda.emisorId);
		this.tokenService.setCompanyRut(emisorConDeuda.rut);
		const sucursalId = this.tokenService.getSubsidiary();
		this.changeCompanyService.SetNewCompany(emisorConDeuda, sucursalId, "/plan-facturacion");
	}

	private deudaYaFueNotificada(emisorId: string): boolean {
		return sessionStorage.getItem(this.debtAlertStoragePrefix + emisorId) === "1";
	}

	private marcarDeudaComoNotificada(emisorId: string): void {
		sessionStorage.setItem(this.debtAlertStoragePrefix + emisorId, "1");
	}
}
